
    <dw-date-picker dwPlaceHolder=""
                    dwFormat="DD/MM/YYYY"
                    [dwShowTime]="false"
                    (ngModelChange)="dateChange($event)"
                    [(ngModel)]="date" dwSize="default">
    </dw-date-picker>
  